export default __webpack_public_path__ + "static/media/homeimg.6c767f2b.jpg";